import React, { useEffect } from 'react'
import NewsLetter from '../NewsLetter/NewsLetter';

const Service = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <NewsLetter />
        </div>
    )
}

export default Service